// One button for the whole planning picture: sync from BC, then rerun the forecast.
import { api } from "../api";

const NAMES: Record<string, string> = { items: "item cards", vendors: "vendors", sales: "sales lines", purchase: "purchase lines", prod_output: "production orders", prod_component: "components", transfer: "transfers", forecast: "demand forecast", requisition: "requisition worksheet", receipts: "receipts", boms: "BOMs" };

export async function refreshPlanning(onStep: (s: string) => void) {
  let r = await api.planSync();
  for (let i = 0; i < 200 && !r.done; i++) { onStep(`Syncing ${NAMES[r.next!.stage] ?? r.next!.stage}…`); r = await api.planSync(r.next!); }
  onStep("Updating the forecast…");
  await api.planRunForecast();
}
